import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  optional: {
    id: '99ffd638d3723fe42446e63b93ac6f7799a9da234b50d0200a688c40b509e811',
    defaultMessage: '(Optional)',
    description: 'Optional field label',
  },
  textTooLong: {
    id: '5508ecc00515da1ae5b914fe2d67829952d4d5307e5e97985922a18947b6b688',
    defaultMessage: 'Text is limited to the available space on the document.',
    description: 'Text too long warning',
  },
  formViewDescription: {
    id: '20d04bf5bc180a00cbc7133c8fe211ba34be0a523960e80da6c6b06f9bf01053',
    defaultMessage:
      'Below is a simplified form view representing a subset of the full agreement document.',
    description:
      'Description text for the form view which inditcates that it is a subset of the original document',
  },
});
